import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { PageHeader } from "@/components/PageHeader";
import { useTranslation } from "react-i18next";

export const CompanyNotFound = () => {
  const { t } = useTranslation();
  return (
    <div className="p-6">
      <PageHeader title={t("companies.notFound.title")} />
      <div className="mb-6">
        <Link to="/companies" className="text-digger-blue hover:underline flex items-center">
          <ArrowLeft className="h-4 w-4 mr-1" />
          {t("companies.notFound.back")}
        </Link>
      </div>
      <div className="bg-white rounded-lg shadow p-6">
        <p>{t("companies.notFound.message")}</p>
      </div>
    </div>
  );
};
